import React from 'react';

const Services = () => {
  return (
    <div>
      <h1>Our Services</h1>
      <p>Explore the services we offer to help your business grow.</p>
    </div>
  );
};

export default Services;
